import {
  ADD_EXAM,
  ADD_EXAM_SUCCESS,
  ADD_EXAM_CLEAN,
  ADD_EXAM_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  exam: undefined,
}

const ExamAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_EXAM:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_EXAM_SUCCESS:
      state = {
        ...state,
        exam: action.payload.exam,
        loading: false,
        done: true,
      }
      break
    case ADD_EXAM_CLEAN:
      state = initialState
      break
    case ADD_EXAM_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default ExamAdd
